import { render } from "./Tarieven.vue?vue&type=template&id=dc2d39d2&scoped=true"
import script from "./Tarieven.vue?vue&type=script&lang=js"
export * from "./Tarieven.vue?vue&type=script&lang=js"

import "./Tarieven.vue?vue&type=style&index=0&id=dc2d39d2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-dc2d39d2"

export default script